/**
 * @function
 * @param {Blob} blob
 * @param {string} filename
 */
export function downloadFile(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
}

/**
 * @function
 * @param {string} rawTitle
 * @returns {string}
 */
export function formatTitle(rawTitle) {
    return (rawTitle || '').replace(/^@.+\s*?\((.+)\)$/g, '$1');
}
